import axios from 'axios';
import { callsHost } from '@/config/index.js';

const apiClient = axios.create({
  baseURL: callsHost,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getCallInfo(userId, roomId, token) {
    return apiClient
      .get(`/api/v1/rest/entities/${userId}/${roomId}/${token}`)
      .catch(error => {
        console.log(`CallInfo: ${error}`);
      });
  }
};
